"use client";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faClock } from "@fortawesome/free-solid-svg-icons";
import Image from "next/image";
import { useTranslation } from "react-i18next";

export const TimeMaterialMode = () => {
  const { t } = useTranslation("workmode");

  const features = t("timeMaterial.features", {
    returnObjects: true,
  }) as string[];

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 p-8">
      <div className="space-y-6">
        <div className="space-y-4">
          <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm font-medium">
            <FontAwesomeIcon icon={faClock} className="text-xs" />
            {t("timeMaterial.badge")}
          </div>

          <h3 className="text-2xl font-bold text-gray-900">
            {t("timeMaterial.title")}
          </h3>

          <p className="text-gray-600 leading-relaxed">
            {t("timeMaterial.description")}
          </p>
        </div>

        <div className="space-y-4">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex items-start gap-3 p-3 rounded-lg bg-blue-50 border border-blue-100"
            >
              <FontAwesomeIcon
                icon={faCheck}
                className="text-blue-600 mt-0.5 flex-shrink-0"
              />
              <span className="text-gray-700">{feature}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="relative h-64 lg:h-80 rounded-2xl overflow-hidden">
        <Image
          src="/spazicoworking/timemanage.png"
          alt={t("timeMaterial.imageAlt")}
          fill
          className="object-cover"
          sizes="(max-width: 768px) 100vw, 50vw"
          priority
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
      </div>
    </div>
  );
};
